import { List, ListItem, QuickGlanceOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getIdElement } from '../../../../util/StringUtil'

export default function ChannelMembersOverlay({ channelId, memberData, ...overlay }) {
  const { t } = useTranslation()
  return (
    <QuickGlanceOverlay {...overlay} title={t('user.messages.channelMembers', 'Channel Members')}>
      <List maxHeight="50vh">
        {memberData &&
          memberData[channelId] &&
          Object.entries(memberData[channelId]).map(([cisId, contactName]) => (
            <ListItem
              key={cisId}
              primaryText={contactName}
              secondaryText={cisId}
              to={`/user/${getIdElement(cisId)}/summary?context=cisUserId`}
              target="_blank"
            />
          ))}
      </List>
    </QuickGlanceOverlay>
  )
}
